import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../types/types';
import { cardOpen } from '../../../../../base/effects/cardOpen';

export const IS_RECENT_CARD_OPENED_SESSIONSTORAGE = 'IS_RECENT_CARD_OPENED_SESSIONSTORAGE';

export const onSelect = (
    cardId: string,
    isRecentCard: boolean,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (isRecentCard) {
            sessionStorage.setItem(IS_RECENT_CARD_OPENED_SESSIONSTORAGE, JSON.stringify(true));
        }
        dispatch(cardOpen(Number(cardId)));
    };
    return action;
};
